// Formatting shared by the QA report and the audit calls pages.
import { engagementLocation } from '../../../router/engagement_routes';

export const fmtPct = (v) => (v === null || v === undefined ? '—' : `${v}%`);

export function fmtDate(v) {
  if (!v) return '';
  const d = new Date(v);
  return Number.isNaN(d.getTime())
    ? String(v).slice(0, 10)
    : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function fmtDuration(seconds) {
  if (!seconds) return '—';
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}

export const sessionLocation = (workId) => engagementLocation(workId);
